import api from './api';

// Shared notification verification + defaults — backs the NotificationsPanel for any
// feature (Payment Porter, Sync, …). Routes to the ui-v2-notifications lambda.
const notificationService = {
    // Returns { hotelEmail, chainEmail } — the hotel/chain contact emails to offer as defaults.
    getDefaults: async (hotelId, accountId) => {
        const params = new URLSearchParams();
        if (hotelId)   params.append('hotel_id',   hotelId);
        if (accountId) params.append('account_id', accountId);
        const res = await api.get(`/notifications/defaults?${params.toString()}`);
        return res.data;
    },
    sendEmailCode:   (email)            => api.post('/notifications/email/send-code',   { email }),
    verifyEmailCode: (email, code)      => api.post('/notifications/email/verify-code', { email, code }),
    sendTeamsCode:   (webhookUrl)       => api.post('/notifications/teams-webhook/send-code',   { webhook_url: webhookUrl }),
    verifyTeamsCode: (webhookUrl, code) => api.post('/notifications/teams-webhook/verify-code', { webhook_url: webhookUrl, code }),

    // PRODUCT NOTIFICATIONS (V703) — a hotel's, chain's or partner's Teams channel per product. level: hotel | chain |
    // partner. Each answers { products, canEdit, entityName }.
    listProductNotifications: async (level, id) =>
        (await api.get('/notifications/products', { params: { level, id } })).data,
    // Set a channel: the URL and the code Teams received (the server checks the code as it keeps the URL).
    saveProductNotification: async (level, id, product, teamsWebhook, code) =>
        (await api.put(`/notifications/products/${encodeURIComponent(product)}`, { teamsWebhook, code }, { params: { level, id } })).data,
    setProductNotificationActive: async (level, id, product, active) =>
        (await api.put(`/notifications/products/${encodeURIComponent(product)}`, { active }, { params: { level, id } })).data,
    removeProductNotification: async (level, id, product) =>
        (await api.delete(`/notifications/products/${encodeURIComponent(product)}`, { params: { level, id } })).data,
    testProductNotification: async (level, id, product) =>
        (await api.post(`/notifications/products/${encodeURIComponent(product)}/test`, {}, { params: { level, id } })).data,
};

export default notificationService;
